import { render } from "./ImageCourseware.vue?vue&type=template&id=1c979a28&scoped=true"
import script from "./ImageCourseware.vue?vue&type=script&lang=js"
export * from "./ImageCourseware.vue?vue&type=script&lang=js"

import "./ImageCourseware.vue?vue&type=style&index=0&id=1c979a28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c979a28"

export default script